/** 
  * @class Resource Class for Meta Content
  * @extends SSResource
  * @param {Object} config An options hash with settings for the Resource
  */
import SSResource from './00-slideshare_resource';

function SSMetaResource(config){
  this.resourceTemplate = {
    url : config.url,
    cacheable: true,
    retries : 2,
    isCritical: true
  };
  
  SSResource.call(this, config);
}

SSMetaResource.prototype = new SSResource();

/** 
  * Configures the resource based on the resourceType
  */
SSMetaResource.prototype._initResourceConfig = function(){
  var resourceTemplate = this.resourceTemplate;
  this.url = resourceTemplate.url + '?' + this.config.timestamp;   
  this.cacheable = resourceTemplate.cacheable;
  this.retries = resourceTemplate.retries || 0;
  this.isCritical = resourceTemplate.isCritical;
};

/**
  * @private
  * Tries to load the resource
  */
SSMetaResource.prototype._tryLoad = function(){    
  $.jsonp({
    url: this.url,
    callback : 'slideshare_jsonp_meta_hook_trigger',
    success : this.resourceLoadedInternalHandler(),
    error : this.resourceErrorInternalHandler(),
    cache : true,
    timeout : 10000
  });
};


/**
  * EventHandler factory for when resource finishes loading successfully
  * @private
  */
SSMetaResource.prototype.resourceLoadedInternalHandler = function(){
  var that = this;
  return function(data){
    that.status = 'loaded';
    $.slideshareEventManager.trigger('metadataloaded', {
      type : that.config.type,
      json : data
    });    
  };
};

/**
  * EventHandler factory for when resource fails to load
  *   Retries this.retries number of times in case of failure before giving up
  * @private
  */
SSMetaResource.prototype.resourceErrorInternalHandler = function(){
  var that = this;
  return function(data){
    var startTime = that.startTime;
    var elapsedTime = (new Date()).getTime() - startTime;
    var retries = that.retries;
    
    if (retries > 0 && elapsedTime < that.TIMEOUT_LIMIT){
      retries = retries - 1;
      that.update({retries : retries});
      setTimeout(function(){
        that._tryLoad();
      },1000);
      
    } else {    
      $.slideshareEventManager.trigger('metadataloadfailed', {
        type : that.config.type
      });
      
    }
  };
};

export default SSMetaResource;
